import { z } from 'zod';
import { chargeTemplateSchema } from './charge-template.schema';
// =============================================================================
// CUSTOM CHARGE SCHEMA
// Represents the API response for POST/PATCH /services/:id/charges/custom
// =============================================================================
export const customChargeSchema = z.object({
    id: z.number().int().positive(),
    service_id: z.number().int().positive(),
    organization_id: z.number().int().positive(),
    name: z.string().min(1),
    description: z.string().nullable().optional(),
    type: z.enum(['FLAT', 'PERCENTAGE']),
    amount: z.number().min(0),
    operation: z.enum(['ADD', 'SUBTRACT']),
    display_mode: z.enum(['LINE_ITEM', 'GROUPED']).default('LINE_ITEM'),
    is_mandatory: z.boolean().default(true),
    compounds_percentage: z.boolean().default(true),
    created_at: z.string(),
    updated_at: z.string(),
});
// =============================================================================
// CREATE / UPDATE SCHEMAS (for form validation)
// =============================================================================
export const createCustomChargeSchema = z.object({
    name: z
        .string()
        .min(1, 'El nombre es requerido')
        .max(60, 'El nombre no puede superar los 60 caracteres'),
    description: z.string().max(255, 'Máximo 255 caracteres').optional(),
    type: z.enum(['FLAT', 'PERCENTAGE'], { required_error: 'El tipo es requerido' }),
    amount: z
        .number({ required_error: 'El monto es requerido', invalid_type_error: 'El monto debe ser un número' })
        .min(0, 'El monto no puede ser negativo'),
    display_mode: z.enum(['LINE_ITEM', 'GROUPED']).default('LINE_ITEM'),
    is_mandatory: z.boolean().default(true),
    compounds_percentage: z.boolean().default(true),
});
// =============================================================================
// SERVICE CHARGES RESPONSE SCHEMA
// Represents the API response for GET /services/:serviceId/charges
// =============================================================================
export const attachedChargeTemplateSchema = z.object({
    id: z.number().int().positive(),
    service_id: z.number().int().positive(),
    charge_template_id: z.number().int().positive(),
    created_at: z.string(),
    chargeTemplate: chargeTemplateSchema,
});
export const serviceChargesResponseSchema = z.object({
    templates: z.array(attachedChargeTemplateSchema),
    custom: z.array(customChargeSchema),
});
